<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Assets<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmsassets/excel-index"> Manage Assets  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Assets  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div class="container-fluid">
                <div class="card bdr-rad2 mt-1 shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <form @submit.prevent="SaveCustomer()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Name </label>
           <input  v-model="customer.asset_name"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Code </label>
           <input  v-model="customer.asset_code"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Description </label>
            <input  v-model="customer.asset_dis"  style="font-size: small;" class="form-control" required>
    </div>
  </div>



  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Department </label>
           
           <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="customer.idcustomer"  :options="departments" ></v-select>
            
    </div>
  </div>

</div>

<div class="row">
  <!-- <div class="col-md-6">
    <div class="form-group required">
          

       <input type="hidden" class="form-control" placeholder="Latitude" v-model="customer.lat" />
    <input type="hidden" class="form-control" placeholder="Longitude" v-model="customer.lng" />
    </div>
  </div>
   -->
   <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Location </label>
           
           <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="customer.location"  :options="locations" ></v-select>
            
    </div>
  </div>
 
<div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">District </label>
            <input  v-model="customer.district"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Country</label>
            <input  v-model="customer.country"  style="font-size: small;" class="form-control" >
    </div>
  </div>
   <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier </label>
               <v-select class="font-size_def" label="label"    v-model="customer.idsupplier"  :options="msuplliers" ></v-select>
    </div>
  </div>
</div>

<div class="row">
 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Warranty End Date </label>
           <input type="date"  v-model="customer.wrty_end_date"  style="font-size: small;" class="form-control" >
    </div>
  </div>
 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">File Upload</label>
           <input 
  type="file" 
  ref="fileInput" 
  @change="handleFileUpload" 
  style="font-size: small;" 
  class="form-control"
/>
    </div>
  </div>

</div>




<!-- <div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">NIC No </label>
            <input  v-model="customer.nic_no"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">NIC</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div> -->

<!-- <div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Business Registration No </label>
            <input  v-model="customer.business_registration_no"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Business Registration Image</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div> -->


<!-- <div class="row">
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">VAT Number </label>
            <input  v-model="customer.vat_number"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">VAT certificate</label>
            <input type="file"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-check mt-4">
      <input class="form-check-input" type="checkbox"  v-model="customer.vat">
      <label class="form-check-label" for="flexCheckChecked">    VAT
      </label>
    </div>
  </div>
</div> -->

<!-- <div class="row mb-2">
  <div class="col-md-3">
    <div class="form-check ms-2">
    <input class="form-check-input" type="checkbox"  v-model="customer.parts">
      <label class="form-check-label" for="flexCheckChecked">   Parts
      </label>
  </div>
  </div>
  <div class="col-md-3">
    <div class="form-check ms-2">
    <input class="form-check-input" type="checkbox" v-model="customer.vehicle" >
      <label class="form-check-label" for="flexCheckChecked">    Vehicles
      </label>
  </div>
  </div>
</div> -->

 

 
   <div>
   

    <!-- <div id="map" style="height: 600px; width: 100%;"></div> -->
    <!-- <div v-if="clickedLocation"> -->
      <!-- <p>Latitude: {{ clickedLocation.lat }}</p>
      <p>Longitude: {{ clickedLocation.lng }}</p> -->
    <!-- </div> -->
  </div>





    <h6 class="purchitem mb-2"><b>Operator Contact List</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover  ">
        <thead  class="background_color2">
          <tr >
           
                <th >   
                  <div  class="form-group custom-form required">
                    <label  class="custom-label2"> Contact Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Designation</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Mobile No</label>
                  </div>
                </th>
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
             
              <td><input  v-model="detail[0].name" style="font-size: small;" class="form-control" required></td>
              <td><input  v-model="detail[0].designation" style="font-size: small;" class="form-control" ></td>
              <td><input  v-model="detail[0].email" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail[0].tel" style="font-size: small;" class="form-control" required></td>
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
           
              <td><input  v-model="detail[key].name" style="font-size: small;" class="form-control" required></td>
              <td><input  v-model="detail[key].designation" style="font-size: small;" class="form-control" ></td>
              <td><input  v-model="detail[key].email" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail[key].tel" style="font-size: small;" class="form-control" required></td>
              <td class="custom-icon"> 
                <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
            
            



          
            
          </tbody>


        </table>
       
    </div>
    

    <!-- <div class="card border-primary mb-3 mt-3">
      <div class="card-header bg-primary text-white" style="font-size: small;">
        Create Assets from Excel
      </div>
      <div class="card-body py-2">
        <div class="row align-items-end">
          <div class="col-md-6">
            <label class="custom-label" style="font-size: small;">Excel File (A-Q columns)</label>
            <input
              type="file"
              accept=".xls,.xlsx,.csv"
              @change="handleExcelUpload"
              class="form-control"
              style="font-size: small;"
            >
          </div>
          <div class="col-md-6 text-right">
            <button
              type="button"
              class="btn btn-outline-primary mb-1 font-size_def bdr-rad"
              :disabled="!excelFile || importingExcel"
              @click="importExcelAssets"
            >
              {{ importingExcel ? 'Importing...' : 'Create Assets from Excel' }}
            </button>
          </div>
        </div>
        <small v-if="excelFile" class="text-muted">Selected: {{ excelFile.name }}</small>
      </div>
    </div> -->

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           <br><br>
            </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
            // this.initMap();
    this.loadSalespeople();
    this.loadDepart();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
         departments:[],
         locations:[],
         msuplliers:[],
        selectedOption: null, // Store the selected option
     searchAddress: '',
file: null,
excelFile: null,
importingExcel: false,

      salespeoples:[

      ],
       customer: {
      lat: null,
      lng: null
    },
     map: null,
    marker: null,
    autocomplete: null,
     
        detail:[
      {},  
      ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    
initMap() {
    const initialLatLng = { lat: 7.8731, lng: 80.7718 }; // Sri Lanka center

    this.map = new google.maps.Map(document.getElementById("map"), {
      center: initialLatLng,
      zoom: 8,
    });

    this.marker = new google.maps.Marker({
      map: this.map,
      position: initialLatLng,
      draggable: true,
    });

    // Autocomplete
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete);
    this.autocomplete.bindTo("bounds", this.map);

    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();

      if (!place.geometry) return;

      this.map.setCenter(place.geometry.location);
      this.map.setZoom(14);
      this.marker.setPosition(place.geometry.location);

      // Update values
      this.customer.lat = place.geometry.location.lat();
      this.customer.lng = place.geometry.location.lng();
      this.searchAddress = place.formatted_address || place.name;
    });

    // Map click to set lat/lng
    this.map.addListener("click", (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.marker.setPosition({ lat, lng });
      this.customer.lat = lat;
      this.customer.lng = lng;

      // Optional: reverse geocode to update address
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.searchAddress = results[0].formatted_address;
        }
      });
    });
  },

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
        
      } catch (error) {
        console.log(error.response);
      }
    },

     async loadDepart() {
       
     
      try {
        const { data} = await  axios.get('/ciinventory/loaddepart',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.departments = data.deps;
         this.locations = data.locs;
         this.msuplliers = data.sups;
        
      } catch (error) {
        console.log(error.response);
      }
    },

handleFileUpload(event) {
  this.file = event.target.files[0];
},

handleExcelUpload(event) {
  this.excelFile = event.target.files[0] || null;
},

async importExcelAssets() {
  if (!this.excelFile) {
    window.alert('Please select an Excel file first.');
    return;
  }

  this.importingExcel = true;
  try {
    const formData = new FormData();
    formData.append('excel_file', this.excelFile);
    formData.append('userid', this.userid);

    const { data } = await axios.post('/ciinventory/import-scada-excel', formData, {
      headers: {
        Authorization: 'Bearer ' + this.access_token,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (data.status === 200) {
      window.alert(data.message);
      this.$router.push('/cmmsassets/excel-index');
    } else {
      window.alert(data.message || 'Excel import failed.');
    }
  } catch (error) {
    const message = error.response && error.response.data
      ? error.response.data.message
      : 'Excel import failed.';
    window.alert(message);
  } finally {
    this.importingExcel = false;
  }
},

   async SaveCustomer() {
  try {
    let formData = new FormData();

    formData.append('userid', this.userid);
    formData.append('customer', JSON.stringify(this.customer));
    formData.append('detail', JSON.stringify(this.detail));

    if (this.file) {
      formData.append('file_my', this.file);
    }

    const { data } = await axios.post(
      '/ciinventory/create',
      formData,
      {
        headers: {
          'Authorization': 'Bearer ' + this.access_token,
          'Content-Type': 'multipart/form-data',
        }
      }
    );

    console.log(data);

    if (data.status === 200) {
      this.$router.push('/cmmsassets/index');
    }

  } catch (error) {
    console.log(error.response);
  }
},

       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style >
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    
